import _sfc_main from "./ManageStageControl.vue2.mjs";
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_c(_setup.TuiBadge, { attrs: { "hidden": _setup.applyToAnchorList.length === 0, "value": _setup.applyToAnchorList.length, "max": 10, "type": "danger" } }, [_c(_setup.IconButton, { attrs: { "title": _setup.t("Apply to stage"), "icon": _setup.StageApplicationIcon, "is-active": _setup.sidebarName === "apply" }, on: { "click-icon": _setup.toggleManageStage } })], 1), _c(_setup.MasterApplyControl, { directives: [{ name: "show", rawName: "v-show", value: _setup.showApplyUserList, expression: "showApplyUserList" }] })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const MasterApplyControl = __component__.exports;
export {
  MasterApplyControl as default
};
